module.exports = __webpack_public_path__ + "static/media/mirror-selfie.eca8eee0.JPG";